export default __webpack_public_path__ + "static/media/Waiting-pana.8bdecbd9.svg";